import { render } from "./PolicyDetailHeader.vue?vue&type=template&id=aee2f8b2"
import script from "./PolicyDetailHeader.vue?vue&type=script&lang=js"
export * from "./PolicyDetailHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__